import { ParamType } from '@forvalter/utils/ParamType';
import type { IPortfolio } from './IPortfolio';
import {
    clearStorage,
    getFromStorage,
    saveToStorage,
} from '@forvalter/utils/storage';

export class Portfolio {
    public static emptyId = '';

    brukerId: IPortfolio['brukerId'];
    created: IPortfolio['created'];
    epost: IPortfolio['epost'];
    etternavn: IPortfolio['etternavn'];
    fornavn: IPortfolio['fornavn'];
    isDeleted: IPortfolio['isDeleted'];
    lastUpdated?: IPortfolio['lastUpdated'];
    superOfficeId: IPortfolio['superOfficeId'];
    isOkonomi: IPortfolio['isOkonomi'];
    isForvalter: IPortfolio['isForvalter'];
    region: IPortfolio['region'];
    roller: IPortfolio['roller'];

    constructor(props: IPortfolio) {
        Object.assign(this, props);

        this.created = new Date(props.created);
        this.lastUpdated = props.lastUpdated
            ? new Date(props.lastUpdated)
            : undefined;
    }

    public static parseObject(obj: IPortfolio): Portfolio {
        try {
            return new Portfolio(obj);
        } catch (error) {
            throw new Error(
                `Could not parse Portfolio object : ${JSON.stringify(obj)}`,
            );
        }
    }

    public static empty() {
        return Portfolio.parseObject({
            brukerId: Portfolio.emptyId,
            created: new Date(),
            epost: '',
            etternavn: '',
            fornavn: '',
            isDeleted: false,
            superOfficeId: 0,
            isOkonomi: false,
            isForvalter: false,
            region: '',
            roller: [],
        });
    }

    public static get storedSelectedPortfolio() {
        const portfolio = getFromStorage<Portfolio>(
            ParamType.storedSelectedPortfolio,
        );
        return portfolio ? Portfolio.parseObject(portfolio) : undefined;
    }
    public static set storedSelectedPortfolio(value: Portfolio | undefined) {
        if (value) {
            saveToStorage(ParamType.storedSelectedPortfolio, value);
        } else {
            clearStorage(ParamType.storedSelectedPortfolio);
        }
    }
}
